import TechService from './techService';
import servicesUtils from './servicesUtils';
import rgpdConf from '../constants/rgpd';

/**
 * getCookie - Return all cookies set in browser
 * @param {*} cookieName - cookie to get
 */
function getCookie(cookieName) {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArr = decodedCookie.split(';');
  let decode;
  for (let i = 0; i < cookieArr.length; i += 1) {
    let cookie = cookieArr[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      decode = cookie.substring(name.length, cookie.length);
    }
  }
  return decode;
}

function setCookie(cName, value, exdays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cValue = escape(value) + ((exdays == null) ? '' : `; expires=${exdate.toUTCString()}`);
  document.cookie = `${cName}=${cValue};path=/`;
}

/**
 * createRgpdCookie
 */
function createRgpdCookie() {
  const expiration = new Date(Date.now() + (13 * 30 * 24 * 60 * 60 * 1000)).toUTCString();
  const encodedRgpdConf = encodeURIComponent(JSON.stringify(rgpdConf));
  document.cookie = `rgpd=${encodedRgpdConf}; expires=${expiration}; path=/`;
}

/**
 * setRedirectionLink
 * @param {*} defaultLink - set redirection Link for CnilBanner
 * @returns {string}
 */
function setRedirectionLink(defaultLink) {
  const currentUrl = window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);
  const newUrl = `${defaultLink}?paramUrl=${encodedUrl}`;
  return newUrl;
}

function getPathname() {
  return window.location.pathname.split('/');
}

function getBaseUrl() {
  const currentUrl = getPathname().filter(item => (item !== ''));
  if (currentUrl[0] === '') {
    return 'home';
  }
  return currentUrl[0];
}

/**
 * setupAds - initialize dfp ads
 * @param {*} data - formatted object from webservice
 */
function setupAds({ data }) {
  const monetizationIso = window.monetization_iso;
  const { adsDataContext, adsContext } = data.monetization;
  if (monetizationIso) {
    const ads = servicesUtils.monetization(data.monetization);
    const adsIds = ads.map(key => ads[key].id);
    monetizationIso.initialize(adsContext, adsDataContext, adsIds);
  }
}

/**
 * triggerMonetization - trigger Dfp ads from BROWSER
 */
function triggerMonetization(wsParams) {
  // expose functions from TechService utils
  const instance = TechService.getBrowserInstance();
  const baseUrl = `/${getBaseUrl()}`;


  return instance.monetization(baseUrl, null, null, wsParams)
    .then(setupAds);
}


/**
 * create visitorUSACookie
 */
function createVisitorUSACookie(urlRedirect) {
  if (typeof window !== 'undefined') {
    if (urlRedirect === 'https://www.rakuten.com') {
      document.cookie = 'visitor-usa=true; domain=.rakuten.com; path=/';
    }
  }
}


export default {
  triggerMonetization,
  getCookie,
  createRgpdCookie,
  setRedirectionLink,
  createVisitorUSACookie,
  setCookie,
};
